import { useAuthTokensRefreshData } from '../../contexts/AuthContext';
import { useIsLoggingIn } from '../useIsLoggingIn';

export const useIsLoggedIn = (): boolean => {
  const { isTokenValid } = useAuthTokensRefreshData();
  const isLoggingIn = useIsLoggingIn();

  return !isLoggingIn && isTokenValid;
};
